import { createSlice } from "@reduxjs/toolkit";
import { alarmTripCount } from "../../actions/alarmTripCount/alarmTripCount";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const alarmTripCountReducer = createSlice({
  name: "alarmTripCountReducer",
  initialState,
  reducers: {
    clearalarmTripCountReducer: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(alarmTripCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(alarmTripCount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(alarmTripCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearalarmTripCountReducer } = alarmTripCountReducer.actions;
export default alarmTripCountReducer.reducer;
